/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { OnePassValues } from 'client-code/onepass';

import { OnePassServiceRepositoryImpl } from '../impls/OnePassServiceRepositoryImpl';
import { IOnePassServiceRepository } from '../interfaces';
import { IOnePassService } from '../interfaces/IOnePassService';
import {
    TOnePassList,
    TOnePassListParams,
    TOnePassOptions,
    TOnePassPreviewItem,
    TOnePassUCIdPreivewParams,
    TOnePassValuesWithDisplayOptions,
    TServicesParams,
} from '../types';

export class OnePassService implements IOnePassService {
    private mOnePassServiceRepository: IOnePassServiceRepository;

    public constructor(params: TServicesParams) {
        this.mOnePassServiceRepository = new OnePassServiceRepositoryImpl(params);
    }

    /**
     * @inheritdoc
     */
    public createOnePass(
        unifiedCollectionId: string,
        onePassValues: OnePassValues,
        networkCallId?: number,
    ): Promise<void> {
        return this.mOnePassServiceRepository.createOnePass(
            unifiedCollectionId,
            onePassValues,
            networkCallId,
        );
    }

    /**
     * @inheritdoc
     */
    public deleteOnePass(unifiedCollectionId: string, networkCallId?: number): Promise<void> {
        return this.mOnePassServiceRepository.deleteOnePass(unifiedCollectionId, networkCallId);
    }

    /**
     * @inheritdoc
     */
    public getOnePassList(onePassListParams: TOnePassListParams): Promise<TOnePassList> {
        return this.mOnePassServiceRepository.getOnePassList(onePassListParams);
    }

    /**
     * @inheritdoc
     */
    public getOnePassOptions(
        unifiedCollectionId: string,
        networkCallId?: number,
        channelId?: string,
        contentId?: string,
    ): Promise<TOnePassOptions> {
        return this.mOnePassServiceRepository.getOnePassOptions(
            unifiedCollectionId,
            networkCallId,
            channelId,
            contentId,
        );
    }

    /**
     * @inheritdoc
     */
    public getValuesWithDisplayOptions(
        unifiedCollectionId: string,
        networkCallId?: number,
        channelId?: string,
        contentId?: string,
    ): Promise<TOnePassValuesWithDisplayOptions> {
        return this.mOnePassServiceRepository.getValuesWithDisplayOptions(
            unifiedCollectionId,
            networkCallId,
            channelId,
            contentId,
        );
    }

    /**
     * @inheritdoc
     */
    public updateOnePass(
        unifiedCollectionId: string,
        onePassValues: OnePassValues,
        networkCallId?: number,
    ): Promise<void> {
        return this.mOnePassServiceRepository.updateOnePass(
            unifiedCollectionId,
            onePassValues,
            networkCallId,
        );
    }

    /**
     * @inheritdoc
     */
    public async getOnePassPreviewItemByUCId(
        onePassUCIdPreivewParams: TOnePassUCIdPreivewParams,
    ): Promise<TOnePassPreviewItem> {
        return this.mOnePassServiceRepository.getOnePassPreviewItemByUCId(onePassUCIdPreivewParams);
    }
}
